export default __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-0085819b.png";